import { type FunctionalComponent, h } from '@stencil/core'

interface IconProps {
  name: string
  size?: number
  color?: string
}

export const Icon: FunctionalComponent<IconProps> = ({ name, size = 24, color = 'black' }) => {
  const getIconSvg = (iconName: string) => {
    const icons: { [key: string]: string } = {
      star: `<svg xmlns="http://www.w3.org/2000/svg" width=${size} height=${size} viewBox="0 0 16 16" fill="none">
          <path d="M8.1875 0.6875L9.12531 3.22189C9.78366 5.00107 11.1864 6.40384 12.9656 7.06219L15.5 8L12.9656 8.93781C11.1864 9.59616 9.78366 10.9989 9.12531 12.7781L8.1875 15.3125L7.24969 12.7781C6.59134 10.9989 5.18857 9.59616 3.40939 8.93781L0.875 8L3.40939 7.06219C5.18857 6.40384 6.59134 5.00107 7.24969 3.22189L8.1875 0.6875Z" fill="url(#paint0_radial_1183_175)"/>
          <defs>
          <radialGradient id="paint0_radial_1183_175" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16.5 -9.5) rotate(141.053) scale(24.2042)">
          <stop stop-color="#6A4BB2"/>
          <stop offset="1"/>
          </radialGradient>
          </defs>
        </svg>`,
      starFour: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path d="M14.3434 7.06266L10.379 5.62516L8.93717 1.65641C8.86613 1.46503 8.73823 1.29998 8.57064 1.18342C8.40305 1.06687 8.20381 1.00439 7.99967 1.00439C7.79554 1.00439 7.59629 1.06687 7.4287 1.18342C7.26111 1.29998 7.13321 1.46503 7.06217 1.65641L5.62467 5.62078L1.65592 7.06266C1.46454 7.1337 1.29949 7.2616 1.18294 7.42919C1.06638 7.59678 1.00391 7.79602 1.00391 8.00016C1.00391 8.20429 1.06638 8.40354 1.18294 8.57113C1.29949 8.73872 1.46454 8.86662 1.65592 8.93766L5.6203 10.3752L7.06217 14.3439C7.13321 14.5353 7.26111 14.7003 7.4287 14.8169C7.59629 14.9334 7.79554 14.9959 7.99967 14.9959C8.20381 14.9959 8.40305 14.9334 8.57064 14.8169C8.73823 14.7003 8.86613 14.5353 8.93717 14.3439L10.379 10.3789L14.3434 8.93766C14.5348 8.86662 14.6999 8.73872 14.8164 8.57113C14.933 8.40354 14.9954 8.20429 14.9954 8.00016C14.9954 7.79602 14.933 7.59678 14.8164 7.42919C14.6999 7.2616 14.5348 7.1337 14.3434 7.06266ZM10.0353 9.43766C9.89849 9.48763 9.77424 9.56687 9.67125 9.66986C9.56826 9.77285 9.48901 9.8971 9.43905 10.0339L7.99967 13.9939L6.56217 10.0358C6.51224 9.89844 6.4328 9.7737 6.32946 9.67037C6.22613 9.56703 6.10139 9.48759 5.96405 9.43766L2.00592 8.00016L5.96405 6.56266C6.10139 6.51272 6.22613 6.43329 6.32946 6.32995C6.4328 6.22661 6.51224 6.10188 6.56217 5.96453L7.99967 2.00641L9.43717 5.96453C9.48714 6.10134 9.56639 6.22559 9.66938 6.32858C9.77237 6.43157 9.89661 6.51082 10.0334 6.56078L13.9915 7.99828L10.0353 9.43766Z" />
      </svg>`,
    }
    return icons[iconName] || ''
  }

  return (
    <div
      innerHTML={getIconSvg(name)}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        fill: color,
        display: 'inline-block',
        verticalAlign: 'middle',
      }}
    />
  )
}
